import { call, takeLatest, select, take } from 'redux-saga/effects';

import { FETCH_DEALER_SUCCESS, SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { putAndWait } from 'modules/app/sagas';
import { scopeToPage } from 'modules/app/sagas/utils';
import type { Nullable } from 'modules/global/typing/common/common';
import * as actions from 'modules/metrics/actions/core.actions';
import * as actionTypes from 'modules/metrics/actionTypes';
import { isCurrentUserIsAdminOrGroupManager } from 'modules/users/selectors/currentUser';
import { getSelectedDealerId } from 'selectors/dealerSelectors';

import { getEffectiveEntity, getFetchParams } from '../selectors';

function* refreshMetrics() {
  const entity: ReturnType<typeof getEffectiveEntity> = yield select(getEffectiveEntity);
  const params: ReturnType<typeof getFetchParams> = yield select(getFetchParams);
  yield putAndWait(actions.fetchBillingMetrics({ entity, ...params }, { entity }));
}

function* waitingOnAppStarted() {
  const selectedDealerId: Nullable<string> = yield select(getSelectedDealerId);
  const isAdminOrGroupManager: boolean = yield select(isCurrentUserIsAdminOrGroupManager);

  if (!isAdminOrGroupManager && !selectedDealerId) {
    yield take(FETCH_DEALER_SUCCESS);
  }
}

const refreshTypes = [SELECT_DEALER, actionTypes.SET_BILLING_DASHBOARD_FILTERS, actionTypes.SET_DOCUMENTS_TAB];

function* onDashboardWorker() {
  yield call(waitingOnAppStarted);
  yield call(refreshMetrics);
  yield takeLatest(refreshTypes, refreshMetrics);
}

export default function* metricsDashboardSaga() {
  yield scopeToPage([PATH.BILLING], onDashboardWorker);
}
